import agent from "../services/Api/agent";

export default class ResourceDataStore {

    loadingInitial: boolean = false;
    private setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state
    }

    getResourceData= async (locationID: number, resourceTypeID?: number, includeHistory?: boolean) => {
        try {
            this.setLoadingInitial(true);
            const res = await agent.Data.getResourceData(locationID, resourceTypeID, includeHistory);
            this.setLoadingInitial(false);
            return res;
        }
        catch (error) {
            this.setLoadingInitial(false);
            throw (error);
        }
    }
}